import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Redirect till lämplig startsida
    if (isAuthenticated) {
      navigate('/app', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, isAuthenticated]);

  // Visar inget medan redirect sker
  return null;
}
